import {
  ErrorMessage,
  FieldValuesFromFieldErrors,
} from "@hookform/error-message";
import { Alert, Box } from "@mui/material";
import { ReactElement } from "react";
import {
  useFormState,
  Control,
  FieldValues,
  FieldName,
  FieldErrors,
  GlobalError,
} from "react-hook-form";

export const defaultErrorField = "root";

type FormErrors<Values extends FieldValues> = FieldErrors<Values> & {
  [defaultErrorField]?: GlobalError;
};

export function RhfErrorBanner<Values extends FieldValues>({
  name = defaultErrorField as FieldName<
    FieldValuesFromFieldErrors<FormErrors<Values>>
  >,
  control,
}: {
  name?: FieldName<FieldValuesFromFieldErrors<FormErrors<Values>>>;
  control: Control<Values>;
}): ReactElement {
  const { errors } = useFormState({ control });

  return (
    <Box>
      <ErrorMessage<FormErrors<Values>>
        errors={errors}
        name={name}
        render={({ message, messages = {} }) => {
          if (!messages && !message) {
            return null;
          }

          return (
            <Alert severity="error" sx={{ marginBottom: 3 }}>
              {message && <p>{message}</p>}
              {Object.entries(messages).map(([type, message]) => (
                <p key={type}>{message}</p>
              ))}
            </Alert>
          );
        }}
      />
    </Box>
  );
}
